import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// third-party
import SimpleBar from 'simplebar-react';
import { BrowserView, MobileView } from 'react-device-detect';

// root style
const RootStyle = styled(BrowserView)({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',

  backgroundColor: 'hsl(214 17% 26%)',
  marginTop: 10
});

// scroll bar wrapper
const SimpleBarStyle = styled(SimpleBar)(() => ({
  maxHeight: '100%',

  backgroundColor: 'hsl(214 17% 26%)',
  '& .simplebar-scrollbar': {
    backgroundColor: 'hsl(214 17% 26%)',
    '&:before': {
      backgroundColor: 'hsl(214 17% 26%)'
    },
    '&.simplebar-visible:before': {
      backgroundColor: 'hsl(214 17% 26%)',
      opacity: 1
    }
  },
  '& .simplebar-track.simplebar-vertical': {
    backgroundColor: 'hsl(214 17% 26%)',
    width: 10
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    backgroundColor: 'hsl(214 17% 26%)',
    height: 6
  },
  '& .simplebar-mask': {
    zIndex: 'inherit'
  }
}));

// ==============================|| SIMPLE SCROLL BAR  ||============================== //

export default function SimpleBarScroll({ children, sx, ...other }) {
  return (
    <>
      <RootStyle>
        <SimpleBarStyle timeout={500} clickOnTrack={false} sx={sx} {...other}>
          {children}
        </SimpleBarStyle>
      </RootStyle>
      <MobileView>
        <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
          {children}
        </Box>
      </MobileView>
    </>
  );
}

SimpleBarScroll.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};
